import React, { useLayoutEffect } from 'react';
import { MarketHero } from '../components/market/MarketHero';
import { MarketGrid } from '../components/market/MarketGrid';
import { MarketScroll } from '../components/market/MarketScroll';
import { EcoFriendlySection } from '../components/EcoFriendlySection';
import { Testimonials } from '../components/Testimonials';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';

export const MarketProducts = () => {
  
  // Scroll to top on mount
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-background min-h-screen w-full">
      <SEO 
        title="Markets & Products - PrintAura"
        description="Explore PrintAura's premium mono-carton packaging solutions for cosmetics, electronics, food & beverages, pharmaceuticals, and more. Custom packaging for every industry."
        keywords="packaging solutions, mono-carton types, custom packaging, cosmetics packaging, food packaging, pharmaceutical packaging"
        url="https://printaura.co.in/products"
      />
      <MarketHero />
      <MarketGrid />
      <MarketScroll />
      <EcoFriendlySection/>
      <Testimonials/>
      <Footer/>
    </main>
  );
};
